import TagManager from 'react-gtm-module';

import {
  DeferredNavigationProps,
  deferredNavigationFields,
} from './clickTracking';

export interface TrackActivityNavClickProps extends DeferredNavigationProps {
  data: {
    /** Path the click happened on, e.g. `/en/category/camping-gear` */
    interactionLocation: string;
    /**
     * The grid's own heading, e.g. "Explore by activity" — tells apart two
     * grids on the same page, which share an `interaction_location`.
     */
    heading: string;
    /** Locale-prefixed href the card navigates to */
    linkUrl: string;
    /** The activity label, e.g. "Tents" */
    linkText: string;
    /** 0-based position of the card within the grid */
    index: number;
  };
}

/**
 * ED-415 — Activity Navigation Grid card clicks.
 *
 * The grid renders on both CIP and CLP, and the spec carries no `type` field
 * to tell them apart: `interaction_location` is the path the click happened
 * on, so the two surfaces are already distinguishable in reporting without
 * one.
 */
export const trackActivityNavClick = ({
  data,
  ...deferral
}: TrackActivityNavClickProps) => {
  const { interactionLocation, heading, linkUrl, linkText, index } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_activity_nav',
      interaction: {
        interaction_location: interactionLocation,
        heading,
        link_url: linkUrl,
        link_text: linkText,
        // Sent as a string to match the ticket spec and trackMainHeroEvents —
        // GA4 reads it as a dimension, not a metric.
        index: index.toString(),
      },
      ...deferredNavigationFields(deferral),
    },
  });
};
